import { ShieldAlert } from "lucide-react";
import { Card, Button } from "@/components/ui";

export default function UnauthorizedDomainPage() {
  return (
    <div className="min-h-screen bg-dark flex items-center justify-center p-4">
      <Card className="p-8 max-w-md text-center" hover={false}>
        <div className="w-16 h-16 rounded-full bg-red-500/20 flex items-center justify-center mx-auto mb-4">
          <ShieldAlert className="w-8 h-8 text-red-400" />
        </div>
        <h1 className="text-2xl font-bold text-text-primary mb-2">
          Acesso não autorizado
        </h1>
        <p className="text-text-secondary mb-6">
          Este domínio não está autorizado para acessar o sistema. Entre em
          contato com o administrador para liberar o acesso.
        </p>
        <Button onClick={() => window.location.reload()}>
          Tentar novamente
        </Button>
      </Card>
    </div>
  );
}
